"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaiveXLSXBook = void 0;
const XLSX = __importStar(require("xlsx"));
const NaiveSheet_1 = require("./NaiveSheet");
// TODO: Streaming Read should be supported
//       Currently it reads the whole file at once
class NaiveXLSXBook {
    constructor(workbook) {
        this.sheets = workbook.SheetNames.map((sheetName) => {
            const sheet = workbook.Sheets[sheetName];
            // Set read range
            // https://stackoverflow.com/questions/76588411/dont-skip-empty-rows-columns-at-the-beginning-with-sheetjs
            const ref = sheet["!ref"];
            if (!ref) {
                throw new Error(`SheetJS Error: !ref was not defined in the sheet: ${sheetName}`);
            }
            const range = XLSX.utils.decode_range(ref);
            range.s.c = 0;
            range.s.r = 0;
            sheet["!ref"] = XLSX.utils.encode_range(range);
            const rows = XLSX.utils
                .sheet_to_json(sheet, {
                header: 1,
                defval: "",
                raw: true,
            })
                .map((row) => row.map((cell) => String(cell)));
            return new NaiveSheet_1.NaiveSheet(sheetName, rows);
        });
    }
}
exports.NaiveXLSXBook = NaiveXLSXBook;
